<template>
  <div class="home">
    <div class="hero-banner">
      <div class="hero-content">
        <img class="hero-brand" :src="heroBrandImage" alt="" />
        <div class="hero-title">{{ $t('home.heroTitle') }}</div>
      </div>
    </div>
    <div class="container">
      <div class="title">{{ $t('home.coreBusiness') }}</div>
      <div class="line-container">
        <div class="line short-line"></div>
        <div class="line middle-line"></div>
        <div class="line short-line" style="transform: scaleX(-1)"></div>
      </div>
      <div class="hero-icon-list">
        <div class="hero-icon-item" v-for="(item, index) in heroItems" :key="index">
          <img :src="item.icon" alt="" />
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div class="core-business flex mt100">
        <img src="@/assets/images/0_img_1.png" alt="" />
        <div class="right">
          <div class="title flex">
            <div class="triangle"></div>
            <span>{{ $t('home.platform') }}</span>
          </div>
          <div class="text">{{ $t('home.formulation') }}</div>
          <div class="list flex">
            <section>
              <div class="sec-title">{{ $t('home.dosageForm') }}</div>
              <div class="sec-text">
                {{ $t('home.dosageForms.oralFilms') }} <br />
                {{ $t('home.dosageForms.transdermal') }} <br />
                {{ $t('home.dosageForms.granule') }}
              </div>
            </section>
            <section>
              <div class="sec-title">{{ $t('home.application') }}</div>
              <div class="sec-text">
                {{ $t('home.applicationText') }}
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="title flex title-2">
        <div class="triangle"></div>
        <span>{{ $t('home.platform') }}</span>
      </div>
      <div class="flex step-list">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_2.png" alt="" />
          <div class="step-text">{{ $t('home.productStrategy') }}</div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_3.png" alt="" />
          <div class="step-text">
            {{ $t('home.productInfo') }}
          </div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_4.png" alt="" />
          <div class="step-text">{{ $t('home.productRegistration') }}</div>
        </div>
      </div>
      <div class="flex step-list step-list-bot">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_5.png" alt="" />
          <div class="step-text">{{ $t('home.salesMarket') }}</div>
        </div>
        <div class="li li-5 special-effects">
          <img src="@/assets/images/0_img_6.png" alt="" />
          <div class="step-text">
            {{ $t('home.supplyDistribution') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  computed: {
    heroBrandImage() {
      return this.$i18n.locale === 'ja'
        ? require('@/assets/images/new/0_img_jp.png')
        : require('@/assets/images/new/0_img_en.png')
    },
    heroItems() {
      return [
        { icon: require('@/assets/images/new/1_icon_1.png'), text: this.$t('home.heroItem1') },
        { icon: require('@/assets/images/new/1_icon_2.png'), text: this.$t('home.heroItem2') },
        { icon: require('@/assets/images/new/1_icon_3.png'), text: this.$t('home.heroItem3') },
        { icon: require('@/assets/images/new/1_icon_4.png'), text: this.$t('home.heroItem4') },
        { icon: require('@/assets/images/new/1_icon_5.png'), text: this.$t('home.heroItem5') },
        { icon: require('@/assets/images/new/1_icon_6.png'), text: this.$t('home.heroItem6') },
        { icon: require('@/assets/images/new/1_icon_7.png'), text: this.$t('home.heroItem7') }
      ]
    }
  }
};
</script>
<style lang="less" scoped>
.hero-banner {
  height: 270px;
  background: url('@/assets/images/new/0_img_bg.png') center center / cover no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.hero-content {
  width: 1200px;
  text-align: center;
}
.hero-brand {
  width: auto;
  height: 70px;
  object-fit: contain;
}
.hero-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin-top: 18px;
}
.hero-subtitle {
  margin-top: 14px;
  font-size: 22px;
  line-height: 1.5;
}
.hero-icon-list {
  margin-top: 34px;
  display: flex;
  justify-content: space-between;
}
.hero-icon-item {
  width: 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 42px;
    height: 42px;
    object-fit: contain;
  }
  div {
    margin-top: 12px;
    font-size: 15px;
    line-height: 1.3;
    min-height: 40px;
    color: #654495;
    font-weight: 600;
  }
}
.title {
  align-items: center;
  .triangle {
    width: 0;
    height: 0;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 50px solid orange;
  }
  span {
    font-size: 30px;
    font-weight: bolder;
    margin-left: 20px;
  }
}
.core-business {
  .right {
    margin-left: 25px;
    .text {
      margin-top: 20px;
      font-size: 32px;
      color: #999;
      font-weight: 100;
    }
    .list {
      justify-content: space-between;
      margin-top: 20px;
      section {
        width: 306px;
        height: 219px;
        background: #f9f9f9;
        padding: 38px 20px;
        box-sizing: border-box;
      }
      .sec-title {
        font-size: 18px;
        font-weight: bolder;
        color: #654495;
      }
      .sec-text {
        line-height: 35px;
        font-size: 18px;
        margin-top: 11px;
      }
    }
  }
}
.title-2 {
  margin-top: 60px;
}
.step-list {
  margin-top: 50px;
  flex-wrap: wrap;
  justify-content: space-between;
  .li {
    width: 400px;
    height: 322px;
    background: #f9f9f9;
  }
  .step-text {
    height: 70px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: pre-line;
  }
}
.step-list-bot{
  justify-content: center;
  .li-5{
    margin-left: 50px;
  }
}
</style>
